var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "contentful-rich-text-container"
  }, [_c('ContentfulRichTextRenderer', {
    "class": _vm.customClass,
    attrs: {
      "document": _vm.document
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }